import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { magpCMSApi } from "~/Services";
export interface CPOsOffice {
  id: number;
  field_cpo_name_en: string;
  field_cpo_name_ms: string;
  field_cpo_name_zh: string;
  field_cpo_designation_en: string;
  field_cpo_designation_ms: string;
  field_cpo_designation_zh: string;
  field_cpo_department: string;
  field_cpo_email: string;
  field_cpo_phone_number: string;
  field_created_cpopage_date: string;
  field_updated_cpopage_date: string;
  field_cpopage_published: boolean;
  field_department: string;
}

interface Excellence {
  id: number;
  name: string;
  field_profile_name_en: string;
  field_profile_name_ms: string;
  field_profile_name_zh: string;
  field_profile_designation_en: string;
  field_profile_designation_ms: string;
  field_profile_designation_zh: string;
  field_unit_subcategory_en: string;
  field_unit_subcategory_ms: string;
  field_unit_subcategory_zh: string;
  field_email_id: string;
  field_phone_number: string;
  field_contact_profile_published: boolean;
  field_contact_profile_created_at: string;
  field_contact_profile_updated_at: string;
  departmentId: number;
  field_department_reference: number;
}

interface addContactDirectory {
  id: number;
  name: string;
  field_department_name_ms: string;
  field_department_name_zh: string;
  field_department_published: number;
}

const useCPOsOffice = (
  options?: UseQueryOptions<CPOsOffice[], DefaultError, CPOsOffice[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<CPOsOffice[], DefaultError> => {
  return useQuery<CPOsOffice[], DefaultError, CPOsOffice[], QueryKey>(
    {
      queryKey: ["CPOsOffice"],
      enabled: false,
      queryFn: async (): Promise<CPOsOffice[]> => {
        const response = await magpCMSApi.get<CPOsOffice[]>(`/api/cpo-contact-directory/all-fields`);

        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useExcellence = (
  id?: any,
  contactDirKey?: any,
  options?: UseQueryOptions<Excellence[], DefaultError, Excellence[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Excellence[], DefaultError> => {
  return useQuery<Excellence[], DefaultError, Excellence[], QueryKey>(
    {
      queryKey: [contactDirKey, id],
      enabled: false,
      queryFn: async (): Promise<Excellence[]> => {
        if (!id) {
          return null;
        }
        const response = await magpCMSApi.get<Excellence[]>(`/api/web-contact-directory-profile-id/${id}`);
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useAddContactDirectory = (
  id?: any,
  contactDirKey?: any,
  options?: UseQueryOptions<addContactDirectory[], DefaultError, addContactDirectory[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<addContactDirectory[], DefaultError> => {
  return useQuery<addContactDirectory[], DefaultError, addContactDirectory[], QueryKey>(
    {
      queryKey: [contactDirKey, id],
      enabled: false,
      queryFn: async (): Promise<addContactDirectory[]> => {
        if (!id) {
          return null;
        }
        const response = await magpCMSApi.get<addContactDirectory[]>(`/api/get-contact-directory-departments/all-fields/${id}`);
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

const useOperaion = (
  id?: any,
  options?: UseQueryOptions<Excellence[], DefaultError, Excellence[], QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<Excellence[], DefaultError> => {
  return useQuery<Excellence[], DefaultError, Excellence[], QueryKey>(
    {
      queryKey: ["operation", id],
      enabled: false,
      queryFn: async (): Promise<Excellence[]> => {
        if (!id) {
          return null;
        }
        const response = await magpCMSApi.get<Excellence[]>(`/api/web-contact-directory-profile-id/${id}`);
        return response.data;
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { useCPOsOffice, useExcellence, useOperaion, useAddContactDirectory };
